import { render, staticRenderFns } from "./SpeechRec.vue?vue&type=template&id=7eca89cd&"
import script from "./SpeechRec.vue?vue&type=script&lang=js&"
export * from "./SpeechRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports